<template>
  <footer id="footer">
    <div class="footer-inner">
      <p class="link-top-01">
        <a href="" @click.prevent="goToTop()">
          <span>
            <img src="@/assets/images/icn-pagetop-01.png" alt="トップへ戻る" />
          </span>
        </a>
      </p>
      <div class="column-01">
        <p class="copy">
          <small>©Yamato Transport Co., Ltd. All Rights Reserved.</small>
        </p>
        <ul class="link-01">
          <li>
            <a href="" @click.prevent="transitionToMemberTermOfService">{{
              $t("KYG000000.label.footer_transition_to_member_term_of_service")
            }}</a>
          </li>
          <li>
            <a href="" @click.prevent="transitionToPrivacy">
              {{ $t("KYG000000.label.footer_privacy") }}
            </a>
          </li>
          <li>
            <a href="" @click.prevent="transitionToAgreement">
              {{ $t("KYG000000.label.footer_agreement") }}
            </a>
          </li>
          <li>
            <a href="" @click.prevent="transitionToHome">
              {{ $t("KYG000000.label.footer_home") }}
            </a>
          </li>
        </ul>
      </div>
      <!-- /.footer-inner -->
    </div>
    <!-- /#footer -->
  </footer>
</template>

<script>
import url from "@/constants/url-const";
import CommonService from "@/core/utils/common-service";

export default {
  name: "PageFooter",
  methods: {
    openWindow(link) {
      window.open(
        link,
        "blank",
        "top=0,left=0,width=750, height=600, scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1"
      );
    },
    transitionToMemberTermOfService() {
      this.openWindow(url.LINK_YMT_MEMBERS_TERMS_OF_SERVICE);
    },
    transitionToPrivacy() {
      window.open(url.LINK_YMT_PRIVACY);
    },
    transitionToAgreement() {
      window.open(url.LINK_YMT_AGREEMENT);
    },
    transitionToHome() {
      window.open(url.LINK_YMT_HOME);
    },
    goToTop() {
      CommonService.animateScroll("html, body", 0);
    }
  }
};
</script>
